import { NavBar } from 'components/NavBar/NavBar'
import { Receiving } from 'pages/Procurement/Tabs/Receiving'
import { Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'

export const InventoryReceiving = () => {
  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <Flex column gap='0.25rem'>
            <MainHeadline>Receiving</MainHeadline>
            <OtherText grey>Purchase orders from Procurement arrive here automatically on delivery — no manual entry</OtherText>
          </Flex>
        </Flex>
        <Receiving standalone />
      </PageWrapper>
    </>
  )
}
